import React from "react";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";

import PageTitle from "../../layouts/PageTitle";
import { createRole, updateRole } from "../../../services/academicService";
import { toast } from "react-toastify";

const AddRole = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const editUser = location.state?.user || null;
  const mode = location.state?.mode || "add";

  const [name, setName] = React.useState(editUser?.name || "");
  const [status, setStatus] = React.useState(editUser?.status || "");
  const [errors, setErrors] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const handleChange = (e) => {
    setName(e.target.value);
    setErrors((prev) => ({ ...prev, name: "" }));
  };

  const handleStatusChange = (selected) => {
    setStatus(selected?.value || "");
    setErrors((prev) => ({ ...prev, status: "" }));
  };

  const validate = () => {
    const newErrors = {};

    if (!name.trim()) newErrors.name = "Name is required";
    if (!status) newErrors.status = "Status is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // return true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return; // stop if validation fails
    setLoading(true);
    const payload = {
      name,
      status,
    };

    try {
      if (mode === "edit" && editUser?.id) {
        payload.id = editUser.id;
        const res = await createRole(payload);
        if (res) {
          toast.success("Role Updated successfully!", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          navigate("/admin/all-roles");
        }
      } else {
        const res = await createRole(payload);
        if (res) {
          toast.success("Role created successfully!", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          navigate("/admin/all-roles");
        }
      }
    } catch (error) {
      console.error("Error submitting role data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle
        activeMenu={mode === "edit" ? "Edit Role" : "Add Role"}
        motherMenu={"Role"}
      />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                {mode === "edit" ? "Edit Role" : "Add Role"}
              </h4>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Name */}
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="name">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        id="name"
                        placeholder="Enter Name"
                        type="text"
                        // className="form-control"
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        // required
                        name="name"
                        value={name}
                        onChange={handleChange}
                      />
                      {errors.name && (
                        <small className="text-danger m-lg-2">
                          {errors.name}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Status */}
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label className="form-label">
                        Status <span className="required">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        options={[
                          { value: "ACTIVE", label: "Active" },
                          { value: "INACTIVE", label: "Inactive" },
                        ]}
                        placeholder="Select Status"
                        className="custom-react-select"
                        onChange={handleStatusChange}
                        value={
                          status
                            ? {
                                value: status,
                                label:
                                  status.charAt(0).toUpperCase() +
                                  status.slice(1).toLowerCase(),
                              }
                            : null
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.status
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.status
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.status
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.status && (
                        <small className="text-danger m-lg-2">
                          {errors.status}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="submit"
                      className="btn btn-primary me-1"
                      disabled={loading}
                    >
                      {loading
                        ? mode === "edit"
                          ? "Updating..."
                          : "Submitting..."
                        : mode === "edit"
                        ? "Update"
                        : "Submit"}
                    </button>
                    <button
                      type="button"
                      onClick={() => navigate("/admin/all-roles")}
                      className="btn btn-danger light"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRole;
